/*
 * LOCAL WISHLIST: temporary replacement for the Hulk Wishlist app.
 * Stores wishlisted products in localStorage. See snippets/local-wishlist-assets.liquid
 * for how to remove it.
 *
 * Public API: window.LocalWishlist.items() / has(id) / add(item) / remove(id) / toggle(item)
 * Fires `local-wishlist:change` on document whenever the list changes.
 */
(function () {
  'use strict';

  if (window.LocalWishlist) return;

  // Must not contain "hulk" or "wishlist": hulk-wishlist-cleanup.liquid deletes those keys.
  var STORAGE_KEY = 'vahro_saved_items';
  var MAX_ITEMS = 100;
  var CARD_SECTION = 'local-wishlist-card';
  var BUTTON_SELECTOR = '[data-local-wishlist]';

  function read() {
    try {
      var items = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      return Array.isArray(items) ? items.filter(isValid) : [];
    } catch (e) {
      return [];
    }
  }

  function isValid(item) {
    return item && item.id && item.handle;
  }

  function write(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (e) {}
    notify();
  }

  function has(id) {
    id = String(id);
    return read().some(function (item) { return String(item.id) === id; });
  }

  function add(item) {
    if (!isValid(item)) return;
    var id = String(item.id);
    var items = read().filter(function (saved) { return String(saved.id) !== id; });
    items.unshift({
      id: id,
      handle: item.handle,
      variantId: item.variantId ? String(item.variantId) : null,
      addedAt: Date.now()
    });
    write(items);
  }

  function remove(id) {
    id = String(id);
    write(read().filter(function (item) { return String(item.id) !== id; }));
  }

  function toggle(item) {
    if (has(item.id)) {
      remove(item.id);
      return false;
    }
    add(item);
    return true;
  }

  function notify() {
    syncButtons(document);
    syncCounts();
    document.dispatchEvent(new CustomEvent('local-wishlist:change', { detail: { items: read() } }));
  }

  function syncButtons(root) {
    var ids = read().map(function (item) { return String(item.id); });
    root.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      var added = ids.indexOf(button.getAttribute('data-proid')) !== -1;
      var value = added ? 'true' : 'false';
      // Only touch changed buttons: events-branch.js watches data-added mutations.
      if (button.getAttribute('data-added') === value) return;
      var label = added ? 'Remove from wishlist' : 'Add to wishlist';
      button.setAttribute('data-added', value);
      button.setAttribute('aria-pressed', value);
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  }

  // Header / bottom bar badges: <span data-local-wishlist-count hidden></span>
  function syncCounts() {
    var total = read().length;
    document.querySelectorAll('[data-local-wishlist-count]').forEach(function (badge) {
      badge.textContent = total > 99 ? '99+' : String(total);
      badge.hidden = total === 0;
    });
  }

  function handleClick(event) {
    var button = event.target.closest && event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    event.preventDefault();

    var item = {
      id: button.getAttribute('data-proid'),
      handle: button.getAttribute('data-handle'),
      variantId: button.getAttribute('data-varid')
    };
    // Deferred so other click listeners (Branch events) still see the pre-click state.
    setTimeout(function () { toggle(item); }, 0);
  }

  /*
   * SearchTap results (assets/searchtap.js). SearchTap still renders the old Hulk
   * button in each result card ([data-gridhulklist], hidden by
   * hulk-wishlist-cleanup.liquid). Our heart is appended to the same container
   * (the image wrapper) and kept in step with it; SearchTap's own markup is
   * never changed, only added to.
   */
  var HEART_SVG =
    '<svg class="local-wishlist-btn__heart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12.0003 8.63697C12.0003 6.10572 9.94485 4.04088 7.40657 4.04088C4.86829 4.04088 2.81282 6.09635 2.81282 8.63463C2.74954 13.587 12.0003 19.9596 12.0003 19.9596C12.0003 19.9596 21.2534 13.5846 21.1878 8.63228C21.1878 6.094 19.13 4.04088 16.5941 4.04088C14.0581 4.04088 12.0003 6.10572 12.0003 8.63697Z"/>' +
    '</svg>';

  function searchTapHandle(hulkButton) {
    var card = hulkButton.closest('[data-product-id]') || hulkButton.parentNode;
    var link = card && card.querySelector('a[href*="/products/"]');
    var match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function enhanceSearchTap() {
    document.querySelectorAll('[data-gridhulklist]').forEach(function (hulkButton) {
      var container = hulkButton.parentNode;
      var id = hulkButton.getAttribute('data-proid');
      var handle = searchTapHandle(hulkButton);
      if (!container || !id || !handle) return;

      var button = null;
      for (var i = 0; i < container.children.length; i++) {
        if (container.children[i].hasAttribute('data-local-wishlist-searchtap')) button = container.children[i];
      }
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'local-wishlist-btn local-wishlist-btn--card';
        button.setAttribute('data-local-wishlist', '');
        button.setAttribute('data-local-wishlist-searchtap', '');
        button.setAttribute('data-wishlist', '');
        button.setAttribute('data-added', 'false');
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', 'Add to wishlist');
        button.setAttribute('title', 'Add to wishlist');
        button.innerHTML = HEART_SVG;
        container.appendChild(button);
      }

      // SearchTap may reuse a card for another product, so always copy the current ids.
      if (button.getAttribute('data-proid') !== id) {
        button.setAttribute('data-proid', id);
        button.setAttribute('data-added', 'false');
        button.setAttribute('aria-pressed', 'false');
      }
      button.setAttribute('data-varid', hulkButton.getAttribute('data-varid') || '');
      button.setAttribute('data-handle', handle);
    });
  }

  // Cards added after load (infinite scroll, recommendations, search) need their state.
  function watchNewButtons() {
    var queued = false;
    new MutationObserver(function (records) {
      if (queued) return;
      var changed = records.some(function (record) {
        return record.type === 'attributes' || record.addedNodes.length > 0;
      });
      if (!changed) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        enhanceSearchTap();
        syncButtons(document);
      }, 50);
    }).observe(document.body, {
      childList: true,
      subtree: true,
      // SearchTap reusing a card for a different product changes the Hulk button's data-proid.
      attributes: true,
      attributeFilter: ['data-proid']
    });
  }

  /* Wishlist page (sections/local-wishlist-page.liquid) */

  var PRODUCTS_QUERY = [
    'query LocalWishlist($ids: [ID!]!, $country: CountryCode) @inContext(country: $country) {',
    '  nodes(ids: $ids) {',
    '    ... on Product {',
    '      id handle title productType availableForSale',
    '      images(first: 2) { nodes { url altText width height } }',
    '      hideFirstImage: metafield(namespace: "theme", key: "hide_first_image") { value }',
    '      priceRange { minVariantPrice { amount currencyCode } }',
    '      options { name }',
    '      variants(first: 100) {',
    '        nodes { id availableForSale selectedOptions { name value } price { amount currencyCode } }',
    '      }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function formatMoney(money) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: money.currencyCode })
        .format(Number(money.amount));
    } catch (e) {
      return money.currencyCode + ' ' + Number(money.amount).toFixed(2);
    }
  }

  function legacyId(gid) {
    return String(gid).split('/').pop();
  }

  function sizedImage(url, width) {
    try {
      var sized = new URL(url);
      sized.searchParams.set('width', width);
      return sized.toString();
    } catch (e) {
      return url;
    }
  }

  // Storefront API product -> the shape the card and the "Move to cart" popup use.
  function normalizeProduct(node) {
    var images = node.images.nodes;
    var hideFirst = node.hideFirstImage && node.hideFirstImage.value === 'true' && images.length > 1;
    var optionNames = node.options.map(function (option) { return option.name; });

    return {
      id: legacyId(node.id),
      handle: node.handle,
      title: node.title,
      type: node.productType,
      available: node.availableForSale,
      image: images[hideFirst ? 1 : 0] || null,
      price: formatMoney(node.priceRange.minVariantPrice),
      options: optionNames,
      variants: node.variants.nodes.map(function (variant) {
        return {
          id: legacyId(variant.id),
          available: variant.availableForSale,
          price: formatMoney(variant.price),
          options: optionNames.map(function (name) {
            var match = variant.selectedOptions.filter(function (option) { return option.name === name; })[0];
            return match ? match.value : null;
          })
        };
      })
    };
  }

  // Same markup and classes as snippets/product-card.liquid (image, title, type,
  // price) plus the X button, Move to cart button and the popup's product data.
  function buildCard(product, settings) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + 'products/' + product.handle;
    var title = escapeHtml(product.title);
    var image = product.image;
    var ratioPadding = { portrait: 125, landscape: 75, square: 100 }[settings.aspectRatio];
    if (!ratioPadding) ratioPadding = image && image.width ? (image.height / image.width) * 100 : 125;

    var popupData = {
      id: Number(product.id),
      title: product.title,
      image: image ? sizedImage(image.url, 240) : null,
      options: product.options,
      variants: product.variants.map(function (variant) {
        return { id: Number(variant.id), options: variant.options, available: variant.available, price: variant.price };
      })
    };
    var firstVariant = product.variants.filter(function (variant) { return variant.available; })[0] || product.variants[0];

    var imageHtml = image
      ? '<img class="product-primary-image" loading="lazy"' +
        ' width="' + (image.width || '') + '" height="' + (image.height || '') + '"' +
        ' src="' + escapeHtml(sizedImage(image.url, 770)) + '"' +
        ' srcset="' + escapeHtml(sizedImage(image.url, 375)) + ' 375w, ' + escapeHtml(sizedImage(image.url, 770)) + ' 770w"' +
        ' sizes="(min-width: 768px) 25vw, 50vw"' +
        ' alt="' + escapeHtml(image.altText || product.title) + '">'
      : '';

    return '' +
      '<div class="local-wishlist-card" data-local-wishlist-card="' + product.id + '">' +
        '<product-card class="product-card text-' + escapeHtml(settings.contentAlignment) + '"' +
        ' data-product-name="' + title + '" data-product-url="' + escapeHtml(url) + '"' +
        ' data-product-price="' + escapeHtml(product.price) + '">' +
          '<div class="product-card-media">' +
            '<button type="button" class="local-wishlist-btn local-wishlist-btn--card" data-local-wishlist data-wishlist' +
            ' data-added="true" data-proid="' + product.id + '" data-varid="' + (firstVariant ? firstVariant.id : '') + '"' +
            ' data-handle="' + escapeHtml(product.handle) + '" aria-pressed="true"' +
            ' aria-label="Remove from wishlist" title="Remove from wishlist">' +
              '<svg class="local-wishlist-btn__remove" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
            '<figure class="product-card--featured-image product-card--featured-image--' + escapeHtml(settings.imageFit) + '">' +
              '<span class="product-card--badges ' + escapeHtml(settings.badgePosition) + ' font-proxima">' +
                (product.available ? '' : '<span class="badge out-of-stock">' + escapeHtml(settings.soldOutLabel) + '</span>') +
              '</span>' +
              '<a href="' + escapeHtml(url) + '" title="' + title + '"' +
              ' class="product-card--featured-image-link aspect-ratio aspect-ratio--' + escapeHtml(settings.aspectRatio) + '"' +
              ' style="--padding-bottom: ' + ratioPadding.toFixed(1) + '%;">' + imageHtml + '</a>' +
            '</figure>' +
          '</div>' +
          '<div class="product-card-info" data-product-name="' + title + '"' +
          ' data-product-price="' + escapeHtml(product.price.replace(/[^\d.,]/g, '')) + '"' +
          ' data-ga-item-id="' + product.id + '">' +
            '<a href="' + escapeHtml(url) + '" title="' + title + '" class="product-card-title font-zimra">' + title + '</a>' +
            (product.type ? '<div class="product-card-type font-proxima">' + escapeHtml(product.type) + '</div>' : '') +
            '<span class="price font-proxima"><span class="amount discounted selling-price">' + escapeHtml(product.price) + '</span></span>' +
          '</div>' +
        '</product-card>' +
        (product.available
          ? '<button type="button" class="button full local-wishlist-card__move" data-local-wishlist-move>Move to cart</button>'
          : '<button type="button" class="button full local-wishlist-card__move" disabled>' + escapeHtml(settings.soldOutLabel) + '</button>') +
        '<script type="application/json" data-local-wishlist-product>' +
          JSON.stringify(popupData).replace(/</g, '\\u003c') +
        '</script>' +
      '</div>';
  }

  // All saved products in one Storefront API request.
  function fetchCardsFromStorefront(items, page) {
    var settings = {
      aspectRatio: page.getAttribute('data-aspect-ratio') || 'portrait',
      imageFit: page.getAttribute('data-image-fit') || 'cover',
      contentAlignment: page.getAttribute('data-content-alignment') || 'left',
      badgePosition: page.getAttribute('data-badge-position') || 'top left',
      soldOutLabel: page.getAttribute('data-sold-out-label') || 'Sold out'
    };

    return fetch(page.getAttribute('data-storefront-endpoint'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': page.getAttribute('data-storefront-token')
      },
      body: JSON.stringify({
        query: PRODUCTS_QUERY,
        variables: {
          ids: items.map(function (item) { return 'gid://shopify/Product/' + item.id; }),
          country: page.getAttribute('data-country') || null
        }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Storefront API ' + response.status);
        return response.json();
      })
      .then(function (json) {
        if (!json.data || !Array.isArray(json.data.nodes)) throw new Error('Storefront API returned no products');
        // nodes come back in the order requested; deleted/unpublished products are null.
        return items.map(function (item, index) {
          var node = json.data.nodes[index];
          return node ? { item: item, html: buildCard(normalizeProduct(node), settings) } : { item: item, missing: true };
        });
      });
  }

  function loadCards(items, page) {
    if (!items.length) return Promise.resolve([]);
    if (!page.getAttribute('data-storefront-token')) return Promise.all(items.map(fetchCard));

    return fetchCardsFromStorefront(items, page).catch(function (error) {
      console.warn('[LocalWishlist] Storefront API failed, loading cards one by one.', error);
      return Promise.all(items.map(fetchCard));
    });
  }

  // Fallback: one Section Rendering API request per product.
  function fetchCard(item) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + 'products/' + encodeURIComponent(item.handle) + '?section_id=' + CARD_SECTION;

    return fetch(url)
      .then(function (response) {
        if (response.status === 404) return { item: item, missing: true };
        if (!response.ok) return { item: item };
        return response.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-local-wishlist-card]');
          return card ? { item: item, html: card.outerHTML } : { item: item, missing: true };
        });
      })
      .catch(function () { return { item: item }; });
  }

  // Adds the variant the same way the theme's quick add does (cart drawer + bubble
  // refresh), then takes the product off the wishlist.
  function moveToCart(product, variantId, card) {
    var productCard = card && card.querySelector('product-card');
    var sections = productCard && typeof productCard.getSectionsToRender === 'function'
      ? productCard.getSectionsToRender()
      : [];
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    var formData = new FormData();

    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (sections.length) {
      formData.append('sections', sections.map(function (section) { return section.section; }));
      formData.append('sections_url', window.location.pathname);
    }

    return fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Could not add this item to your cart.');
        }

        if (sections.length && typeof productCard.renderContents === 'function') {
          productCard.renderContents(response);
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
        if (typeof window.dispatchCustomEvent === 'function') {
          window.dispatchCustomEvent('cart:item-added', { product: response.items ? response.items[0] : response });
        }

        remove(product.id);
        return response;
      });
  }

  function uniqueValues(product, index) {
    var values = [];
    product.variants.forEach(function (variant) {
      var value = variant.options[index];
      if (values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  // Variant picker for "Move to cart" (markup in sections/local-wishlist-page.liquid).
  function createPopup(root) {
    if (!root) return { open: function () {} };

    var dialog = root.querySelector('[role="dialog"]');
    var image = root.querySelector('[data-popup-image]');
    var title = root.querySelector('[data-popup-title]');
    var price = root.querySelector('[data-popup-price]');
    var optionsEl = root.querySelector('[data-popup-options]');
    var errorEl = root.querySelector('[data-popup-error]');
    var submit = root.querySelector('[data-popup-submit]');
    var state = null;

    function matches(variant, selected, skipIndex) {
      return selected.every(function (value, index) {
        return index === skipIndex || value === null || variant.options[index] === value;
      });
    }

    function selectedVariant() {
      if (state.selected.indexOf(null) !== -1) return null;
      return state.product.variants.filter(function (variant) {
        return matches(variant, state.selected);
      })[0] || null;
    }

    function render() {
      var product = state.product;
      optionsEl.innerHTML = '';

      product.options.forEach(function (name, index) {
        var values = uniqueValues(product, index);
        // A single value (e.g. the one colour of this product) is preselected, so skip showing it.
        if (values.length === 1) return;

        var group = document.createElement('div');
        group.className = 'local-wishlist-popup__option';

        var label = document.createElement('p');
        label.className = 'local-wishlist-popup__option-name';
        label.textContent = name;
        group.appendChild(label);

        var list = document.createElement('div');
        list.className = 'local-wishlist-popup__values';
        list.setAttribute('role', 'group');
        list.setAttribute('aria-label', name);

        values.forEach(function (value) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'local-wishlist-popup__value';
          button.textContent = value;
          button.setAttribute('aria-pressed', state.selected[index] === value ? 'true' : 'false');
          button.disabled = !product.variants.some(function (variant) {
            return variant.available && variant.options[index] === value && matches(variant, state.selected, index);
          });
          button.addEventListener('click', function () {
            state.selected[index] = value;
            errorEl.hidden = true;
            render();
          });
          list.appendChild(button);
        });

        group.appendChild(list);
        optionsEl.appendChild(group);
      });

      var variant = selectedVariant();
      var fallback = product.variants.filter(function (item) { return item.available; })[0] || product.variants[0];
      price.textContent = (variant || fallback).price;
      submit.disabled = !variant || !variant.available;
      submit.textContent = variant && !variant.available ? 'Sold out' : 'Add to cart';
    }

    function close() {
      var trigger = state && state.trigger;
      root.hidden = true;
      document.documentElement.style.overflow = '';
      state = null;
      if (trigger && document.body.contains(trigger)) trigger.focus();
    }

    function open(product, card, trigger) {
      state = {
        product: product,
        card: card,
        trigger: trigger,
        // Options with a single value need no choice.
        selected: product.options.map(function (name, index) {
          var values = uniqueValues(product, index);
          return values.length === 1 ? values[0] : null;
        })
      };

      title.textContent = product.title;
      image.hidden = !product.image;
      if (product.image) {
        image.src = product.image;
        image.alt = product.title;
      }
      errorEl.hidden = true;
      render();

      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      dialog.focus();
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-local-wishlist-popup-close]')) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) close();
    });
    submit.addEventListener('click', function () {
      var variant = state && selectedVariant();
      if (!variant || !variant.available) return;

      submit.disabled = true;
      submit.textContent = 'Adding…';
      moveToCart(state.product, variant.id, state.card)
        .then(close)
        .catch(function (error) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
          if (state) render();
        });
    });

    return { open: open };
  }

  function initPage(page) {
    var grid = page.querySelector('[data-local-wishlist-grid]');
    var empty = page.querySelector('[data-local-wishlist-empty]');
    var loading = page.querySelector('[data-local-wishlist-loading]');
    var popup = createPopup(page.querySelector('[data-local-wishlist-popup]'));
    var rendering = false;

    function updateState() {
      empty.hidden = grid.children.length > 0;
    }

    grid.addEventListener('click', function (event) {
      var button = event.target.closest('[data-local-wishlist-move]');
      if (!button || button.disabled) return;
      event.preventDefault();

      var card = button.closest('[data-local-wishlist-card]');
      var data = card && card.querySelector('[data-local-wishlist-product]');
      if (!data) return;

      var product;
      try {
        product = JSON.parse(data.textContent);
      } catch (e) {
        return;
      }

      var available = product.variants.filter(function (variant) { return variant.available; });
      // Nothing to choose: add the only purchasable variant straight away.
      if (product.variants.length === 1 && available.length === 1) {
        button.disabled = true;
        moveToCart(product, available[0].id, card)
          .catch(function (error) { window.alert(error.message); })
          .then(function () { button.disabled = false; });
        return;
      }
      popup.open(product, card, button);
    });

    function render() {
      rendering = true;
      var items = read();
      loading.hidden = items.length === 0;

      loadCards(items, page).then(function (results) {
        grid.innerHTML = '';
        var missing = [];

        results.forEach(function (result) {
          if (result.missing) {
            missing.push(String(result.item.id));
            return;
          }
          if (!result.html) return;
          var li = document.createElement('li');
          li.className = 'column';
          li.setAttribute('data-local-wishlist-item', result.item.id);
          li.innerHTML = result.html;
          grid.appendChild(li);
        });

        loading.hidden = true;
        rendering = false;
        syncButtons(grid);
        updateState();

        // Products that were deleted or unpublished drop out of the list.
        if (missing.length) {
          write(read().filter(function (item) { return missing.indexOf(String(item.id)) === -1; }));
        }
      });
    }

    document.addEventListener('local-wishlist:change', function () {
      if (rendering) return;
      var ids = read().map(function (item) { return String(item.id); });
      var shown = [];

      grid.querySelectorAll('[data-local-wishlist-item]').forEach(function (li) {
        var id = li.getAttribute('data-local-wishlist-item');
        if (ids.indexOf(id) === -1) {
          li.remove();
        } else {
          shown.push(id);
        }
      });

      // Something was added in another tab: rebuild the grid.
      if (ids.some(function (id) { return shown.indexOf(id) === -1; })) {
        render();
        return;
      }
      updateState();
    });

    render();
  }

  function init() {
    document.addEventListener('click', handleClick);
    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) notify();
    });
    enhanceSearchTap();
    syncButtons(document);
    syncCounts();
    watchNewButtons();
    document.querySelectorAll('[data-local-wishlist-page]').forEach(initPage);
  }

  window.LocalWishlist = {
    items: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
